var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isCurrentUserDealer && _vm.imageExists)?_c('div',{staticClass:"container-fluid section-items banner-container d-none d-sm-none d-md-block"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('img',{staticClass:"banner-img",class:{
        'banner-img_pointer': _vm.link
      },attrs:{"alt":"Main page banner","src":_vm.imgSrc},on:{"click":_vm.openBannerLink}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }